var util = require("./util");
var common = require("./common");
var a11y = require("./a11y");
function PDFRow(options, cells) {
    this.columns = options.columns;
    this.cells = cells || [];
    this.width = options.width;
    this.index = options.index;
    this.setAdjRows(options.prev, options.next);
}
PDFRow.prototype.setAdjRows = function (prev, next) {
    this._next = next;
    this._prev = prev;
    var that = this;
    this.cells.forEach(function (c, i) {
        c.row = that;
        c.adjCells = {
            top: prev && prev[i],
            bottom: next && next[i],
            left: i === 0 ? null : that.cells[i - 1],
            right: that.cells[i + 1] || null,
        };
    });
};
PDFRow.prototype.invalidate = function () {
    this.cells.forEach(function (child) {
        if (typeof child.invalidate === "function")
            child.invalidate();
    });
};
PDFRow.prototype.draw = function (cursor) {
    var borderLeftSpace, borderRightSpace, columns, borderTopSpace = 0, borderBottomSpace = 0;
    if (cursor._columns) {
        borderLeftSpace = cursor._borderLeftSpace;
        borderRightSpace = cursor._borderRightSpace;
        columns = cursor._columns;
    }
    else {
        borderLeftSpace = cursor._borderLeftSpace = this.cells[0].borderLeftWidth / 2;
        borderRightSpace = cursor._borderRightSpace = this.cells[this.cells.length - 1].borderRightWidth / 2;
        columns = cursor._columns = common.calculateColumns(this.columns, cursor.width - borderLeftSpace - borderRightSpace);
    }
    if (!this._prev) {
        borderTopSpace = Math.max.apply(null, this.cells.map(function (c) {
            return c.borderTopWidth / 2;
        }));
    }
    if (!this._next) {
        borderBottomSpace = Math.max.apply(null, this.cells.map(function (c) {
            return c.borderBottomWidth / 2;
        }));
    }
    var childCursor = {
        x: cursor.x + borderLeftSpace,
        y: cursor.y + borderTopSpace,
        height: cursor.height - borderTopSpace - borderBottomSpace,
        doc: cursor.doc,
        _rowHeight: cursor._rowHeight,
        _tableRole: cursor._tableRole,
    };
    var role = cursor._tableRole === "table" ? "table-row" : null;
    if (this.cells.every(function (cell) { return cell.role === "hidden"; })) {
        role = "hidden";
    }
    a11y.structure(cursor, role, function () {
        for (var i = 0; i < this.cells.length; i++) {
            if (this.cells[i].startRow === this.index) {
                childCursor.width = columns[i];
                for (var j = 1; j < this.cells[i].colSpan; j++) {
                    i += 1;
                    childCursor.width += columns[i];
                }
                childCursor._rowHeight = cursor._rowHeight;
                for (var k = 1; k < this.cells[i].rowSpan; k++) {
                    childCursor._rowHeight += cursor._rows[this.index + k];
                }
                childCursor._firstOfPage = cursor._firstOfPage;
                childCursor._lastOfPage = cursor._lastOfPage;
                this.cells[i].draw(childCursor);
                childCursor.x += childCursor.width;
            }
            else {
                childCursor.x += columns[i];
            }
        }
    }, this);
    return {
        width: cursor.width,
        height: cursor._rowHeight,
    };
};
PDFRow.prototype.clone = function (newIndex) {
    var oldIndex = this.index;
    var ret = util.extend(Object.create(PDFRow.prototype), this);
    ret.index = newIndex;
    var indexDelta = newIndex - oldIndex;
    ret.cells = this.cells.map(function (cell) {
        var overrides = { row: ret };
        if (typeof cell.startRow === "number")
            overrides.startRow = cell.startRow + indexDelta;
        return cell.clone(overrides);
    });
    return ret;
};
function fixRows(rows) {
    var newRows = rows.map(function (row) {
        return row.reduce(function (newRow, cell) {
            for (var i = 0; i < cell.colSpan; i++)
                newRow.push(cell);
            return newRow;
        }, []);
    });
    newRows.forEach(function (row, rowNum) {
        row.forEach(function (cell, cellNum) {
            if (typeof cell.startRow !== "undefined" && cell.startRow !== rowNum)
                return;
            var rowSpan = cell.rowSpan;
            cell.startRow = rowNum;
            for (var i = 1; i < rowSpan; i++) {
                newRows[rowNum + i].splice(cellNum, 0, cell);
            }
        });
    });
    return newRows;
}
function PDFTable(options, rows) {
    var that = this;
    rows = fixRows(rows);
    options = options || {};
    this.columns = util.getOption(options, "columns", [1]);
    this.headerRows = util.getOption(options, "headerRows", 0);
    this.width = util.getOption(options, "width", "auto");
    this.rows = (rows || []).map(function (cells, i) {
        return new PDFRow({
            columns: that.columns,
            width: that.width,
            index: i,
            next: rows[i + 1] || null,
            prev: i === 0 ? null : rows[i - 1],
        }, cells);
    });
    this.role = util.getOption(options, "role", "table");
    this.cache = new util.CalcCache();
}
PDFTable.prototype.invalidate = function () {
    this.cache.clear();
    this.rows.forEach(function (child) {
        if (typeof child.invalidate === "function")
            child.invalidate();
    });
};
function hashCursor(cursor) {
    return cursor.width + !!cursor._firstOfPage;
}
function rowCalc(cursor) {
    var borderLeftSpace, borderRightSpace, columns, borderTopSpace = 0, borderBottomSpace = 0;
    if (cursor._columns) {
        borderLeftSpace = cursor._borderLeftSpace;
        borderRightSpace = cursor._borderRightSpace;
        columns = cursor._columns;
    }
    else {
        borderLeftSpace = cursor._borderLeftSpace = this.cells[0].borderLeftWidth / 2;
        borderRightSpace = cursor._borderRightSpace = this.cells[this.cells.length - 1].borderRightWidth / 2;
        columns = cursor._columns = common.calculateColumns(this.columns, cursor.width - borderLeftSpace - borderRightSpace);
    }
    if (!this._prev) {
        borderTopSpace = Math.max.apply(null, this.cells.map(function (c) {
            return c.borderTopWidth / 2;
        }));
    }
    if (!this._next) {
        borderBottomSpace = Math.max.apply(null, this.cells.map(function (c) {
            return c.borderBottomWidth / 2;
        }));
    }
    var childCursor = {
        x: cursor.x + borderLeftSpace,
        y: cursor.y + borderTopSpace,
        height: cursor.height - borderTopSpace - borderBottomSpace,
        doc: cursor.doc,
    }, calcHeight = 0;
    for (var i = 0; i < this.cells.length; i++) {
        if (this.cells[i].rowSpan === 1) {
            childCursor.width = columns[i];
            for (var j = 1; j < this.cells[i].colSpan; j++) {
                i += 1;
                childCursor.width += columns[i];
            }
            var measure = this.cells[i].calc(childCursor);
            calcHeight = Math.max(calcHeight, measure.height);
        }
        childCursor.x += columns[i];
    }
    return {
        width: cursor.width,
        height: calcHeight,
    };
}
PDFTable.prototype.determineColumnsWidths = function (cursor) {
    var row = this.originalRows ? this.originalRows[0] : this.rows[0];
    var borderLeftSpace = (cursor._borderLeftSpace = row.cells[0].borderLeftWidth / 2);
    var borderRightSpace = (cursor._borderRightSpace = row.cells[row.cells.length - 1].borderRightWidth / 2);
    cursor._columns = common.calculateColumns(row.columns, cursor.width - borderLeftSpace - borderRightSpace);
};
PDFTable.prototype.getRowHeights = function (cursor) {
    var childCursor = {
        x: cursor.x,
        y: cursor.y,
        width: this.width === "auto" ? cursor.width : this.width,
        height: cursor.height,
        doc: cursor.doc,
    };
    this.determineColumnsWidths(childCursor);
    var rows = this.rows;
    if (this._headerRows && (this._isFirstSplit || cursor._firstOfPage)) {
        rows = this._headerRows.concat(rows);
    }
    var rowHeights = rows.map(function (row) {
        return rowCalc.call(row, childCursor).height;
    });
    var numRows = rows.length;
    rows.forEach(function (row, rowNum) {
        childCursor._firstOfPage = cursor._firstOfPage && rowNum === 0;
        childCursor._lastOfPage = cursor._lastOfPage && rowNum === numRows - 1;
        row.cells.forEach(function (cell, cellNum) {
            if (cellNum > 0 && cell === row.cells[cellNum - 1])
                return;
            var measure, spanHeight = 0, d, spanHeights = [], tmpHeight;
            if (cell.rowSpan > 1 && cell.startRow === rowNum) {
                for (var i = 0; i < cell.rowSpan; i++) {
                    tmpHeight = rowHeights[rowNum + i];
                    spanHeights.push(tmpHeight);
                    spanHeight += tmpHeight;
                }
                childCursor.width = childCursor._columns[cellNum];
                for (var j = 1; j < cell.colSpan; j++) {
                    childCursor.width += childCursor._columns[cellNum + j];
                }
                measure = cell.calc(childCursor);
                d = measure.height - spanHeight;
                if (d > 0) {
                    spanHeights.forEach(function (h, i) {
                        rowHeights[rowNum + i] += Math.ceil(d * (h / spanHeight));
                    });
                }
            }
        });
    });
    cursor._columns = childCursor._columns;
    return rowHeights;
};
PDFTable.prototype.calc = function (cursor) {
    if (this.cache.has(hashCursor(cursor))) {
        return this.cache.get(hashCursor(cursor));
    }
    var rowHeights = this.getRowHeights(cursor);
    var ret = {
        width: cursor.width,
        height: rowHeights.reduce(function (a, b) {
            return a + b;
        }),
    };
    this.cache.set(hashCursor(cursor), ret);
    return ret;
};
PDFTable.prototype.draw = function (cursor) {
    var rowHeights = this.getRowHeights(cursor);
    var rowCursor = {
        x: cursor.x,
        y: cursor.y,
        width: this.width === "auto" ? cursor.width : this.width,
        height: cursor.height,
        _rows: rowHeights,
        doc: cursor.doc,
        _tableRole: this.role,
    };
    var rows = this.rows;
    if (this._headerRows && (this._isFirstSplit || cursor._firstOfPage)) {
        rows = this._headerRows.concat(rows);
        for (var i = 0; i < rows.length; i++) {
            rows[i].setAdjRows(rows[i - 1] ? rows[i - 1].cells : null, rows[i + 1] ? rows[i + 1].cells : null);
        }
    }
    a11y.structure(cursor, this.role, function () {
        for (var i = 0; i < rows.length; i++) {
            rowCursor._rowHeight = rowHeights[i];
            rowCursor._firstOfPage = cursor._firstOfPage && i === 0;
            rowCursor._lastOfPage = cursor._lastOfPage && i === rows.length - 1;
            rows[i].draw(rowCursor);
            rowCursor.y += rowHeights[i];
        }
    }, this);
    var ret = {
        width: cursor.width,
        height: rowHeights.reduce(function (a, b) {
            return a + b;
        }),
    };
    return ret;
};
PDFTable.prototype.split = function () {
    this._headerRows = this.rows.slice(0, this.headerRows || 0);
    var maxRowSpans = this.rows.map(function (row, rowIndex) {
        return Math.max.apply(null, row.cells.map(function (cell) {
            return cell.startRow === rowIndex ? cell.rowSpan : 0;
        }));
    });
    var splitRows = [];
    for (var i = this.headerRows || 0; i < maxRowSpans.length; i++) {
        var newSplit = [];
        var maxRowSpan = maxRowSpans[i];
        for (var j = 0; j < maxRowSpan; j++) {
            if (j !== 0)
                i++;
            newSplit.push(this.rows[i]);
        }
        splitRows.push(newSplit);
    }
    var _this = this;
    splitRows = splitRows.map(function (rows, i) {
        var ret = _this.cloneWithRows(rows);
        if (i === 0)
            ret._isFirstSplit = true;
        return ret;
    });
    return splitRows;
};
PDFTable.prototype.cloneWithRows = function (rows) {
    var ret = util.extend(Object.create(PDFTable.prototype), this);
    ret.originalRows = ret.rows;
    ret.rows = rows.map(function (row, i) {
        return row.clone(i);
    });
    ret.cache = new util.CalcCache();
    return ret;
};
module.exports = PDFTable;
//# sourceMappingURL=module.js.map